/**
 * Created by tpetridis on 23/2/2017.
 */
export default {
  // User object will let us check authentication status
  showHideModalForHomePage(vm) {
    /* eslint-disable */
    console.log('Inside Generic modals.js /showHideModal HomePage method ');
    vm.$nextTick(() => {
      console.log('ShowHideModal Generic Open HomePage ');
      $('.modal,.modal-overlay').fadeIn(200);
      // show/hide modal
      $('.modal-close, .modal-overlay').unbind().click(function () {
        $('.modal, .modal-overlay').fadeOut();
        vm.storeModalForSettings(null);
        console.log(`ShowHideModal Generic Hide For HomePage: ${vm.$store.state.common.userDetails.subscribed} + ${vm.$root._route.fullPath}`);
        if (vm.$store.state.common.userDetails.subscribed && vm.$root._route.fullPath === '/home/settings') {
          vm.$router.push('/home');
          console.log('ShowHideModal Generic Hide For HomePage inside root to home');
        }
      });
    });
    /* eslint-enable */
  },
  showHideModal(vm) {
    /* eslint-disable */
    console.log('Inside Generic modals.js /showHideModal method ');
    vm.$nextTick(() => {
      console.log('ShowHideModal Generic Open ');
      $('.modal,.modal-overlay').fadeIn(200);
      // show/hide modal
      $('.modal-close, .modal-overlay').unbind().click(function () {
        $('.modal, .modal-overlay').fadeOut();
        console.log('ShowHideModal Generic Hide ');
        vm.storeModalForSettings(null);
      });
    });
    /* eslint-enable */
  },
  hideModal(vm) {
    /* eslint-disable */
    // hide modal
    $('.modal, .modal-overlay').fadeOut();
    console.log('ShowHideModal Generic Hide For hideModal/modal');
    vm.storeModalForSettings(null);
    /* eslint-enable */
  },
  showHideModalForHomeStorePage(vm) {
    /* eslint-disable */
    vm.$nextTick(() => {
      // vm for instance of vue, and in it, the this is for window so the next line is necessary
      // open modal
      $('.modal,.modal-overlay').fadeIn(200);
      // show/hide modal
      $('.modal-close, .modal-overlay').click(() => {
        $('.modal, .modal-overlay').fadeOut();
          console.log("----------------------- Correct Exit For  ResubscribeGame showHideModal");
          vm.storeModalForHomePage(null);
          vm.storeModalForStore(null);
      });
    });
    /* eslint-enable */
  },
  hideModalForHomeStorePage(vm) {
    /* eslint-disable */
    // hide modal
    $('.modal, .modal-overlay').fadeOut();
    console.log("----------------------- Correct Exit ResubscribeGame hideModal");
    vm.storeModalForHomePage(null);
    vm.storeModalForStore(null);
    /* eslint-enable */
  },
};



// WEBPACK FOOTER //
// ./src/common/modals.js